// extracted by mini-css-extract-plugin
export default {"desktopDescription":"nwhWOp","vertical":"yHkMHq","mobileDescription":"ovtjFg"};